<template xmlns="http://www.w3.org/1999/html">
  <div class="wrapper">
    <parallax class="page-header header-filter" style="height: 130px">
    </parallax>
    <div class="main main-raised">
      <div class="section section-basic">
        <div class="container" style="min-height: 500px">
          <div class="contentBox">
            <div class="rightContent">
              <!--              下载信息-->
              <el-card>
                <h3>{{ $t("download.downloadPage") }}</h3>
                <el-divider></el-divider>
                <el-row>
                  <el-col :span="12">
                    <p class="info_title">{{ $t("download.eclipse") }}</p>
                    <p class="info_title">
                      <el-link
                        href="http://mooctest-site.oss-cn-shanghai.aliyuncs.com/target/mooctest.net_plugin.zip"
                        target="_blank"
                        style="color: #337ab6"
                      >
                        {{ $t("download.eclipsePlugin") }}
                      </el-link>
                    </p>
                    <p class="info_title">
                      <el-link
                        href="http://mooctest-site.oss-cn-shanghai.aliyuncs.com/target/eclipse_mac.zip"
                        target="_blank"
                        style="color: #337ab6"
                      >
                        {{ $t("download.macEclipse") }}
                      </el-link>
                    </p>
                    <p class="info_title">
                      <el-link
                        href="http://mooctest-site.oss-cn-shanghai.aliyuncs.com/target/eclipse_win64.zip"
                        target="_blank"
                        style="color: #337ab6"
                      >
                        {{ $t("download.win64WithPluginEclpiseDownload") }}
                      </el-link>
                    </p>

                    <!-- <p class="info_title">{{ $t("download.maven") }}</p>

                    <p class="info_title">
                      <el-link
                        href="http://mirror.olnevhost.net/pub/apache/maven/maven-3/3.6.1/binaries/apache-maven-3.6.1-bin.zip"
                        target="_blank"
                        style="color: #337ab6"
                      >
                      {{ $t("download.maven") }}
                    </el-link>
                    </p> -->
                    <!-- <p class="info_title">
                      <el-link
                        href="http://mooctest-site.oss-cn-shanghai.aliyuncs.com/target/eclipse_win64.zip"
                        target="_blank"
                        style="color: #337ab6"
                      >
                      {{ $t("download.win64WithPluginEclpiseDownload") }}
                    </el-link>
                    </p> -->
                    <p class="info_title">{{ $t("download.jdk") }}</p>

                    <p class="info_title">
                      <el-link
                        href="http://mooctest-site.oss-cn-shanghai.aliyuncs.com/target/jdk-8u201-windows-x64.exe"
                        target="_blank"
                        style="color: #337ab6"
                      >
                        {{ $t("download.win64jdk") }}
                      </el-link>
                    </p>
                    <p class="info_title">jmeter</p>

                    <p class="info_title">
                      <el-link
                        href="http://mooctest-site.oss-cn-shanghai.aliyuncs.com/target/apache-jmeter-2.11-mooctest.zip"
                        target="_blank"
                        style="color: #337ab6"
                      >
                        {{ $t("download.jmeter") }}
                      </el-link>
                    </p>
                    <p class="info_title">{{ $t("download.embedded") }}</p>

                    <p class="info_title">
                      <el-link
                        href="http://mooctest-site.oss-cn-shanghai.aliyuncs.com/target/ETest_win64.zip"
                        target="_blank"
                        style="color: #337ab6"
                      >
                        ETest_win64
                      </el-link>
                    </p>
                  </el-col>
                </el-row>
              </el-card>
            </div>
          </div>
          <div></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Download",
  bodyClass: "index-page",
  data() {
    return {
      role: "STUDENT",
      competitionList: [],
      loading: false,
    };
  },
};
</script>
<style lang="scss">
.section-download {
  .md-button + .md-button {
    margin-left: 5px;
  }
}

@media all and (min-width: 991px) {
  .btn-container {
    display: flex;
  }
}
.info_title {
  font-size: 22px;
  font-weight: bold;
  margin-top: 10px;
  margin-bottom: 12px;
}
</style>
